import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      href='https://www.linkedin.com/in/abhinav-tiruveedhula/' target="_blank" rel="noopener noreferrer"
      className='link footer__link'
    >   
    Abhinav Tiruveedhula </a>
  </footer>
)

export default Footer
